var map = {
	"./language_front.png": 1865,
	"./view10_front.png": 1866,
	"./view11_front.png": 1867,
	"./view1_front.png": 1868,
	"./view5_front.png": 1869,
	"./view6_front.png": 1870,
	"./view8_front.png": 1871,
	"./view9_front.png": 1872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1864;